import { configureStore } from '@reduxjs/toolkit';
import documentSlice from './documentSlice';

export default configureStore({
  reducer: { document: documentSlice },
});
